
    <template>
      <section class="relax-doc">
        <h1>Button 按钮</h1>
<blockquote>
<p>帅气的 Button</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>按钮可以根据 <code>type</code> 来设置不同的颜色，提供了 6 种类型的按钮 <code>primary</code> <code>success</code> <code>info</code> <code>danger</code> <code>warning</code></p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;default&quot;&gt; default &lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot;&gt; warning &lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot;&gt; primary &lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot;&gt; success &lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot;&gt; info &lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot;&gt; danger &lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="lou-kong-an-niu"><a class="header-anchor" href="#lou-kong-an-niu"></a> 镂空按钮</h2>
<blockquote>
<p>设置 <code>plain</code> 属性可以设置镂空按钮</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;default&quot; plain&gt; default &lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; plain&gt; warning &lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; plain&gt; primary &lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; plain&gt; success &lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; plain&gt; info &lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; plain&gt; danger &lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="yuan-jiao-an-niu"><a class="header-anchor" href="#yuan-jiao-an-niu"></a> 圆角按钮</h2>
<blockquote>
<p>设置 <code>round</code> 属性可以设置圆角按钮</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;default&quot; round plain&gt; default &lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; round&gt; warning &lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; round plain&gt; primary &lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; round&gt; success &lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; round plain&gt; info &lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; round&gt; danger &lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="jia-zai-zhong-zhuang-tai"><a class="header-anchor" href="#jia-zai-zhong-zhuang-tai"></a> 加载中状态</h2>
<blockquote>
<p>添加 <code>loading</code> 属性即可让按钮处于加载状态</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;warning&quot; size=&quot;sm&quot; round :loading=&quot;true&quot;&gt;loading&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; round :loading=&quot;true&quot;&gt;loading&lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; round plain :loading=&quot;true&quot;&gt;loading&lt;/x-button&gt;
  &lt;x-button
    type=&quot;success&quot;
    plain
    :loading=&quot;loading1&quot;
    @click=&quot;handerClick1&quot;
    icon=&quot;x-icon-heart-on&quot;
    &gt;loading&lt;/x-button
  &gt;
  &lt;x-button type=&quot;primary&quot; :loading=&quot;loading2&quot; @click=&quot;handerClick2&quot;
    &gt;Click loading&lt;/x-button
  &gt;
&lt;/template&gt;
&lt;script&gt;
  import { ref } from 'vue';
  export default {
    setup() {
      const loading1 = ref(false);
      const loading2 = ref(false);

      const handerClick1 = () =&gt; {
        loading1.value = true;

        setTimeout(() =&gt; {
          loading1.value = false;
        }, 3000);
      };

      const handerClick2 = () =&gt; {
        loading2.value = true;

        setTimeout(() =&gt; {
          loading2.value = false;
        }, 3000);
      };

      return {
        loading1,
        loading2,
        handerClick1,
        handerClick2,
      };
    },
  };
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="tuo-guan-jia-zai-zhuang-tai"><a class="header-anchor" href="#tuo-guan-jia-zai-zhuang-tai"></a> 托管加载状态</h2>
<blockquote>
<p>你只需要返回一个 <code>promise</code>，组件会托管 <code>loading</code>，这在发送请求的时候有奇效</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;warning&quot; @click=&quot;handlePromise&quot;&gt;loading&lt;/x-button&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    setup() {
      const handlePromise = () =&gt;
        new Promise((resolve, reject) =&gt; {
          setTimeout(() =&gt; {
            resolve();
          }, 2000);
        });

      return {
        handlePromise,
      };
    },
  };
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="bu-ke-dian-ji"><a class="header-anchor" href="#bu-ke-dian-ji"></a> 不可点击</h2>
<blockquote>
<p>设置 <code>disabled</code> 属性达到按钮不可点击状态</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo5 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button plain round disabled&gt;default&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; plain round disabled&gt;primary&lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; plain round disabled&gt;success&lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; plain round disabled&gt;info&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; round disabled&gt;danger&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; disabled&gt;warning&lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="an-niu-chi-cun"><a class="header-anchor" href="#an-niu-chi-cun"></a> 按钮尺寸</h2>
<blockquote>
<p>按钮根据<code>size</code>来变换尺寸，提供了 <code>sm</code> <code>md</code> <code>lg</code>三种，默认是<code>md</code></p>
</blockquote>
<demo-block>
        
        <template #source><element-demo6 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; size=&quot;sm&quot;&gt;small&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; size=&quot;md&quot;&gt;default&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; size=&quot;lg&quot;&gt;large&lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="tu-biao-an-niu"><a class="header-anchor" href="#tu-biao-an-niu"></a> 图标按钮</h2>
<blockquote>
<p>圆形的图标按钮</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo7 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button icon=&quot;x-icon-heart-on&quot; circle&gt;&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; icon=&quot;x-icon-x&quot; circle&gt;&lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; icon=&quot;x-icon-mic&quot; circle&gt;&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; icon=&quot;x-icon-music&quot; circle&gt;&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; icon=&quot;x-icon-thumbs-down&quot; circle&gt;&lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; icon=&quot;x-icon-thumbs-up&quot; circle&gt;&lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="tu-biao-an-niu-1"><a class="header-anchor" href="#tu-biao-an-niu-1"></a> 图标按钮</h2>
<blockquote>
<p>有文字信息的图标按钮</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo8 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button icon=&quot;x-icon-home&quot;&gt;default&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; icon=&quot;x-icon-star-on&quot;&gt;primary&lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; icon=&quot;x-icon-search&quot;&gt;success&lt;/x-button&gt;
  &lt;x-button type=&quot;info&quot; icon=&quot;x-icon-user&quot;&gt;info&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; icon=&quot;x-icon-zap&quot;&gt;danger&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; icon=&quot;x-icon-triangle&quot;&gt;warning&lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="kuai-ji-an-niu"><a class="header-anchor" href="#kuai-ji-an-niu"></a> 块级按钮</h2>
<blockquote>
<p>设置 <code>block</code> 属性变成块级按钮</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo9 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;success&quot; icon=&quot;x-icon-heart-on&quot; round block&gt;success&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; icon=&quot;x-icon-star-on&quot; block&gt;warning&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; plain block&gt;primary&lt;/x-button&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, { type: "default" }, {
      default: _withCtx(() => [
        _createTextVNode(" default ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, { type: "warning" }, {
      default: _withCtx(() => [
        _createTextVNode(" warning ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, { type: "primary" }, {
      default: _withCtx(() => [
        _createTextVNode(" primary ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode(" success ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, { type: "info" }, {
      default: _withCtx(() => [
        _createTextVNode(" info ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, { type: "danger" }, {
      default: _withCtx(() => [
        _createTextVNode(" danger ")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "default",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" default ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" warning ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" primary ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "success",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" success ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "info",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" info ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" danger ")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "default",
      round: "",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" default ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      round: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" warning ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      round: "",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" primary ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "success",
      round: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" success ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "info",
      round: "",
      plain: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" info ")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      round: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(" danger ")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "warning",
      size: "sm",
      round: "",
      loading: true
    }, {
      default: _withCtx(() => [
        _createTextVNode("loading")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      round: "",
      loading: true
    }, {
      default: _withCtx(() => [
        _createTextVNode("loading")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "info",
      round: "",
      plain: "",
      loading: true
    }, {
      default: _withCtx(() => [
        _createTextVNode("loading")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "success",
      plain: "",
      loading: _ctx.loading1,
      onClick: _ctx.handerClick1,
      icon: "x-icon-heart-on"
    }, {
      default: _withCtx(() => [
        _createTextVNode("loading")
      ]),
      _: 1
    }, 8, ["loading", "onClick"]),
    _createVNode(_component_x_button, {
      type: "primary",
      loading: _ctx.loading2,
      onClick: _ctx.handerClick2
    }, {
      default: _withCtx(() => [
        _createTextVNode("Click loading")
      ]),
      _: 1
    }, 8, ["loading", "onClick"])
  ], 64))
}
  
    
        const { ref } = Vue
        ;
  const democomponentExport = {
    setup() {
      const loading1 = ref(false);
      const loading2 = ref(false);

      const handerClick1 = () => {
        loading1.value = true;

        setTimeout(() => {
          loading1.value = false;
        }, 3000);
      };

      const handerClick2 = () => {
        loading2.value = true;

        setTimeout(() => {
          loading2.value = false;
        }, 3000);
      };

      return {
        loading1,
        loading2,
        handerClick1,
        handerClick2,
      };
    },
  };
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "warning",
    onClick: _ctx.handlePromise
  }, {
    default: _withCtx(() => [
      _createTextVNode("loading")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    const democomponentExport = {
    setup() {
      const handlePromise = () =>
        new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve();
          }, 2000);
        });

      return {
        handlePromise,
      };
    },
  };
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo5": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      plain: "",
      round: "",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("default")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      round: "",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("primary")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "success",
      plain: "",
      round: "",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("success")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "info",
      plain: "",
      round: "",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("info")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      round: "",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("danger")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      disabled: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("warning")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo6": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      size: "sm"
    }, {
      default: _withCtx(() => [
        _createTextVNode("small")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      size: "md"
    }, {
      default: _withCtx(() => [
        _createTextVNode("default")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      size: "lg"
    }, {
      default: _withCtx(() => [
        _createTextVNode("large")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo7": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      icon: "x-icon-heart-on",
      circle: ""
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      icon: "x-icon-x",
      circle: ""
    }),
    _createVNode(_component_x_button, {
      type: "info",
      icon: "x-icon-mic",
      circle: ""
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      icon: "x-icon-music",
      circle: ""
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      icon: "x-icon-thumbs-down",
      circle: ""
    }),
    _createVNode(_component_x_button, {
      type: "success",
      icon: "x-icon-thumbs-up",
      circle: ""
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo8": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, { icon: "x-icon-home" }, {
      default: _withCtx(() => [
        _createTextVNode("default")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      icon: "x-icon-star-on"
    }, {
      default: _withCtx(() => [
        _createTextVNode("primary")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "success",
      icon: "x-icon-search"
    }, {
      default: _withCtx(() => [
        _createTextVNode("success")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "info",
      icon: "x-icon-user"
    }, {
      default: _withCtx(() => [
        _createTextVNode("info")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "danger",
      icon: "x-icon-zap"
    }, {
      default: _withCtx(() => [
        _createTextVNode("danger")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      icon: "x-icon-triangle"
    }, {
      default: _withCtx(() => [
        _createTextVNode("warning")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo9": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "success",
      icon: "x-icon-heart-on",
      round: "",
      block: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("success")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "warning",
      icon: "x-icon-star-on",
      block: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("warning")
      ]),
      _: 1
    }),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      block: ""
    }, {
      default: _withCtx(() => [
        _createTextVNode("primary")
      ]),
      _: 1
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  